export default "__VITE_ASSET__324ad5f3__"